import { Container } from "@material-ui/core";
import React from "react";
import ContentModulesGrid from "./ModuleGrid";
import ModuleBrandProfile from "./ModuleBrandProfile";
import ModuleImageDescription from "./ModuleImageDescription";
import ModuleOilCoaReport from "./ModuleOilCoaReport";
import ModuleOilCoaReportIngredients from "./ModuleOilCoaReportIngredients";
import ModuleTechSpec from "./ModuleTechSpec";
// import ModuleOilAromasDetailsChart from "./ModuleOilAromasDetailsChart";
// import ModuleOilEffectsChart from "./ModuleOilEffectsChart";
import { DatoCmsProductVariantFragment_modules } from "../../../../../fragments/__generated__/DatoCmsProductVariantFragment";

export const findContentModuleComponent = (modelApiKey: string) => {
  const contentModules = {
    c_module_pv_image_description: ModuleImageDescription,
    c_module_pv_tech_spec: ModuleTechSpec,
    generated_c_module_pv_brand_profile: ModuleBrandProfile,
    generated_c_module_pv_oil_coaReport: ModuleOilCoaReport,
    generated_c_module_pv_oil_coaReport_ingredients: ModuleOilCoaReportIngredients
    // generated_c_module_pv_oil_aromasDetails: ModuleOilAromasDetailsChart,
    // generated_c_module_pv_oil_effectsDetails: ModuleOilEffectsChart
  };
  return contentModules[modelApiKey] || false;
};

type Props = {
  contentModules: DatoCmsProductVariantFragment_modules[];
  id?: string;
};

export default function ProductDetailsContentModules({
  contentModules,
  id
}: Props) {
  if (!contentModules || contentModules.length === 0) {
    return null;
  }

  const availableModules = contentModules
    .map(module => ({
      data: module,
      contentModuleComponent: findContentModuleComponent(module.model.apiKey)
    }))
    .filter(com => !!com.contentModuleComponent);
  if (availableModules.length === 0) {
    return null;
  }

  return (
    <Container maxWidth="md" id={id}>
      <ContentModulesGrid>
        {availableModules.map(({ data, contentModuleComponent }, index) => {
          return React.createElement(contentModuleComponent, {
            key: `${data.model.apiKey}-${index}`,
            data
          });
        })}
      </ContentModulesGrid>
    </Container>
  );
}
